export enum CoverageCreditIncentiveType {
  FIXED = "fixed",
  PERCENTAGE = "percentage",
}

export interface CoverageCreditIncentive {
  enabled: boolean;
  type: CoverageCreditIncentiveType;
  fixedAmount: number;
  percentageSettings: {
    percentage: number;
    storeCreditAmountCap?: number | null;
  };
  minimumQualifyingPurchaseAmount: number;
  creditExpirationDays?: number | null;
  sendEmail: boolean;
  sendExpirationReminderEmail?: boolean;
  expirationReminderDaysBefore?: number | null;
}

export interface PriceBracket {
  value: number;
  pricePoint: number;
}

export interface PricingRuleSet {
  type: "fixed" | "percentage";
  countries: string[];
  priceBrackets: PriceBracket[];
}

export enum DynamicReturnTypes {
  ITEM_COUNT = "item-count",
  CART_VALUE = "cart-value",
}

export interface DynamicReturnsPricingItemCount {
  type: DynamicReturnTypes.ITEM_COUNT;
  pricePerAdditonalItem: number;
  maxPrice: number;
}

export interface DynamicReturnsPricingCartValue {
  type: DynamicReturnTypes.CART_VALUE;
  maxPrice: number;
  pricingRuleSet: PricingRuleSet;
}

export type DynamicReturnPricing =
  | DynamicReturnsPricingCartValue
  | DynamicReturnsPricingItemCount;

export enum PackageProtectionPricingStrategy {
  CART_VALUE = "cart-value",
  PRICE_PER_ITEM = "price-per-item",
}

export interface PackageProtectionPricePerItemPricing {
  basePrice: number;
  pricePerAdditionalItem: number;
  maxPrice: number;
}

export type InternationalReturnPricing = {
  countries: string[];
  multiplier: number;
}[];
